import { z } from 'zod';

/**
 * Klijent na trenerovom popisu.
 *
 * Ovaj oblik je dugo postojao SAMO kao ručno napisano sučelje u portalu
 * (`apps/portal/src/api/types.ts`), a ruta je vraćala nešto sasvim drugo.
 * Prevoditelj to nije mogao uhvatiti, a ni demo: s praznim popisom se nijedno
 * polje ne pročita. Prvi pravi klijent srušio je trenerovu početnu s
 * „Cannot read properties of undefined (reading 'done')".
 *
 * Ista pouka kao kod admin analitike (ARHITEKTURA sekcija 1): oblik odgovora
 * pripada ugovoru, ne ekranu koji ga troši.
 */
export const trainerClientRow = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  /** Dodijeljen plan; `null` dok trener ne dodijeli nijedan. */
  programName: z.string().nullable(),
  lastActiveAt: z.string().nullable(),
  /**
   * Odrađeni / propisani treninzi zadnjeg obračunatog tjedna.
   *
   * Izvor je `weekly_summaries`, isti redak koji vidi i klijent — inače bi
   * trener i klijent gledali dvije različite dosljednosti za isti tjedan.
   * Novi klijent nema sažetak, pa su obje brojke nula.
   */
  consistency: z.object({ done: z.number(), planned: z.number() }),
  missedWorkouts: z.number(),
  hasMeasurements: z.boolean(),
  unreadMessages: z.number(),
});

export const trainerClientsOutput = z.object({ items: z.array(trainerClientRow) });

/** Zadnja mjera na profilu klijenta — samo ono što ekran stvarno pokazuje. */
export const trainerClientMeasurement = z.object({
  measuredOn: z.string(),
  weightKg: z.number().nullable(),
  waistCm: z.number().nullable(),
  hipsCm: z.number().nullable(),
  note: z.string().nullable(),
});

export const trainerClientWorkout = z.object({
  id: z.string(),
  title: z.string(),
  completedAt: z.string().nullable(),
  volumeKg: z.number(),
});

export const trainerClientDetailOutput = trainerClientRow.extend({
  startedAt: z.string().nullable(),
  goal: z.string().nullable(),
  notes: z.string().nullable(),
  latestMeasurement: trainerClientMeasurement.nullable(),
  recentWorkouts: z.array(trainerClientWorkout),
  /** Sekcija 14: fotografije napretka trener vidi samo uz izričito odobrenje. */
  photoAccess: z.boolean(),
});

export type TrainerClientRow = z.infer<typeof trainerClientRow>;
export type TrainerClientsOutput = z.infer<typeof trainerClientsOutput>;
export type TrainerClientDetailOutput = z.infer<typeof trainerClientDetailOutput>;
